import { useStores } from 'hooks';
import { observer } from 'mobx-react-lite';
import React from 'react'
import { MessageWrapper } from './../Styles';
import { FilterCheckboxes } from './FilterCheckboxes';
// import { FilterTextInput } from './FilterTextInput';

const screenCheckboxes = [
  {
    text: 'CLRK',
    value: 'clerk',
  },
  {
    text: 'AUCT',
    value: 'auctioneer',
  },
  {
    text: 'TOTE',
    value: 'tote',
  },
  {
    text: 'LP',
    value: 'login',
  },
];

const messageTypeCheckboxes = [
  {
    text: 'LOG',
    value: 'log',
  },
  {
    text: 'ERROR',
    value: 'error',
  }
];

export const Filters = observer(() => {
  const { DebuggerStore: { filter, logCount } } = useStores();

  if (logCount === 0) return null;
  
  return (
    <MessageWrapper>
      <FilterCheckboxes controls={screenCheckboxes} group="screen" key={`screen-filter-${filter.get('screen')}`} />
      <FilterCheckboxes controls={messageTypeCheckboxes} group="messageType" key={`messageType-filter-${filter.get('messageType')}`} />
      {/* <FilterTextInput key={filterText} /> */}
    </MessageWrapper>
  )
});

export default Filters;
